export default __webpack_public_path__ + "static/media/Төрийн_болон_орон_нутгийн_өмчит_сургуулийн_өмнөх_болон_ерөнхий_боловсролын.6fa57882.pdf";